import * as types from '../constants/actionTypes';

const initialState = {
  logs: [],
  currentLog: null,
  summary: null,
  loading: false,
  summaryLoading: false,
  detailLoading: false,
  error: null,
  filters: {
    entity_type: '',
    action: '',
    entity_id: '',
    user_id: '',
    start_date: '',
    end_date: '',
  },
  pagination: {
    limit: 20,
    offset: 0,
    total: 0,
    has_more: false,
  },
  // Static entity types and actions based on backend specification
  entityTypes: [
    { type: 'vendor', label: 'Vendor' },
    { type: 'kp_product', label: 'KP Product' },
    { type: 'kp_delivery_address', label: 'Delivery Address' },
    { type: 'kp_udhyam_category', label: 'Udhyam Category' },
    { type: 'kp_product_category', label: 'Product Category' },
  ],
  auditActions: [
    { action: 'CREATE', label: 'Create' },
    { action: 'UPDATE', label: 'Update' },
    { action: 'DELETE', label: 'Delete' },
  ],
};

const auditLogReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch audit logs
    case types.FETCH_AUDIT_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_AUDIT_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        logs: action.payload.data || [],
        pagination: {
          ...state.pagination,
          total: action.payload.total || 0,
          limit: action.payload.limit || state.pagination.limit,
          offset: action.payload.offset || 0,
          has_more: action.payload.has_more || false,
        },
        error: null,
      };

    case types.FETCH_AUDIT_LOGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Fetch single audit log
    case types.FETCH_AUDIT_LOG_REQUEST:
      return {
        ...state,
        detailLoading: true,
        error: null,
      };

    case types.FETCH_AUDIT_LOG_SUCCESS:
      return {
        ...state,
        detailLoading: false,
        currentLog: action.payload,
        error: null,
      };

    case types.FETCH_AUDIT_LOG_FAILURE:
      return {
        ...state,
        detailLoading: false,
        error: action.payload,
      };

    // Fetch audit summary
    case types.FETCH_AUDIT_SUMMARY_REQUEST:
      return {
        ...state,
        summaryLoading: true,
        error: null,
      };

    case types.FETCH_AUDIT_SUMMARY_SUCCESS:
      return {
        ...state,
        summaryLoading: false,
        summary: action.payload,
        error: null,
      };

    case types.FETCH_AUDIT_SUMMARY_FAILURE:
      return {
        ...state,
        summaryLoading: false,
        error: action.payload,
      };


    // Set filters
    case types.SET_AUDIT_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };

    // Clear filters
    case types.CLEAR_AUDIT_FILTERS:
      return {
        ...state,
        filters: initialState.filters,
      };

    // Set pagination
    case types.SET_AUDIT_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.payload,
        },
      };

    default:
      return state;
  }
};

export default auditLogReducer;
